module.exports = __webpack_public_path__ + "static/media/Argentina.75284345.png";